import home from 'VIEWS/router.js';
import share from 'VIEWS/share/router.js';
let routes = [];
let myRoutes = routes.concat(
    home,share
);
export default myRoutes;
